import { render, staticRenderFns } from "./listingDetails.vue?vue&type=template&id=0bfdf208&scoped=true"
import script from "./listingDetails.vue?vue&type=script&lang=js"
export * from "./listingDetails.vue?vue&type=script&lang=js"
import style0 from "./listingDetails.vue?vue&type=style&index=0&id=0bfdf208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfdf208",
  null
  
)

export default component.exports